import ui from '@/content/fi/ui.fi.json'

/**
 * All Finnish UI-chrome strings live in src/content/fi/ui.fi.json (DESIGN-BRIEF
 * §5: Finnish content never lives inside components). WP-E3 extends that file;
 * this accessor keeps the keys type-checked so a typo fails the build, not the
 * runtime.
 */
export type UiKey = keyof typeof ui

export function t(key: UiKey): string {
  return ui[key] ?? key
}

export { ui }
